
// Statusvariablen, um zu tracken, ob die Events bereits gefeuert wurden
let eventOneValid = false;
let eventTwoValid = false;
let productDataArray;

// Funktion, die nur ausgeführt wird, wenn beide Events gefeuert wurden
function combinedEventLogic() {
    if (eventOneValid && eventTwoValid) {
        
        //for pages that are not product pages, the addtocart might happen further down the page, so the message cannot be seen
   window.scrollTo(0, 0);


        setTimeout(function() {
    const drawerClose = document.querySelector('button[aria-label="Warenkorb schließen"]');
    
    drawerClose.click();

    showRecommendedProducts(productDataArray, productDataArray.length);



}, 1500);


        
    }
}

// Event-Listener für das erste Event
window.addEventListener('recommendedProducts', function(event) {
  

    productDataArray = JSON.parse(event.detail.array);
    //ascending lowest first
    productDataArray = productDataArray.sort((a, b) => a.price - b.price);
    
    //descending highest first
    //productDataArray = productDataArray.sort((a, b) => b.price - a.price);
    eventOneValid = true;  // Setzt den Status auf 'wahr'
    combinedEventLogic();   // Prüft, ob beide Events gefeuert wurden
});

// Event-Listener für das zweite Event
window.addEventListener('drawerOpened', function(event) {
  

    eventTwoValid = true;   // Setzt den Status auf 'wahr'
    combinedEventLogic();   // Prüft, ob beide Events gefeuert wurden
});

function showRecommendedProducts(data, maxProducts) {
    const main = document.querySelector("#main");

    // Falls auf einer Gempage-Seite -> ausblenden
    const gempageContainer = document.querySelector(".gryffeditor");
    if (gempageContainer) {
        gempageContainer.style.opacity = "0";
    }

    const mainParent = main.parentNode;
    main.style.visibility = "hidden";

    const overlayButton = document.getElementById("myBtn");
    if (overlayButton) {
        overlayButton.style.display = "none";
    }

    const nav = document.getElementById("section-header");
    nav.scrollIntoView({ behavior: "smooth", block: "start" });

    let backElement = document.createElement("a");
    backElement.innerText = "← zurück zur Produktseite";
    backElement.classList.add("recommendations-back-element");
    backElement.addEventListener("click", () => {
        showProductPage();
    });

    let toCheckoutElement = document.createElement("a");
    toCheckoutElement.innerText = "Zur Kasse →";
    toCheckoutElement.classList.add("recommendations-to-checkout");
    toCheckoutElement.href = "/checkout";

    toCheckoutElement.addEventListener("click", () => {

        pushEventToDataLayer("recommendedProductToCheckoutButtonClick", "", window.location.href, "");
        
    });

    let navWrapper = document.createElement("div");
    navWrapper.classList.add("recommendations-nav-wrapper");
    navWrapper.appendChild(backElement);
    navWrapper.appendChild(toCheckoutElement);

    let mainHeadlineElement = document.createElement("div");
    mainHeadlineElement.classList.add("recommendations-mainheadline");
    mainHeadlineElement.innerText = "Diese Weiterbildungen passen perfekt dazu";



    let upsellContainer = document.querySelector(".recommendations-container");
    if (upsellContainer) {
        upsellContainer.innerHTML = "";
    } else {
        upsellContainer = document.createElement("div");
        upsellContainer.classList.add("recommendations-container");
    }
    upsellContainer.appendChild(navWrapper);
    upsellContainer.appendChild(mainHeadlineElement)
    mainParent.insertBefore(upsellContainer, main);

    let delay = 0; // Verzögerung für jedes Element

    data.slice(0, maxProducts).forEach((product, index) => {
        setTimeout(() => {
            
            let imageLink = product.image;
            let type = product.productType.toLowerCase();
            let title = product.title ?? "Diese Weiterbildung passt perfekt dazu";
            title = title.replace(/^ODMS\s*\|\s*/, "").trim();
            let benefitText = "Dein perfektes Weiterbildungsangebot zu Online-Marketing-Themen und allen Fragen rund um dein Digital-Business.";

            if(type.includes("academy")){
                
                benefitText = "Dein interaktiver Online-Campus für die wichtigsten Digital- und Marketing-Themen. Ideal für Einsteiger*innen und mit personalisiertem Abschlusszertifikat.";

            }

            if(type.includes("deep")){

                benefitText = "Profitiere in Live-Sessions von den Erfahrungen unserer Branchen-Expert*innen. Immer inkl. hilfreicher Use Cases und Best Practices.";

            }

            if(type.includes("report")){

                benefitText = "Die Praxis-Guides zu den wichtigsten Online-Marketing-Themen. Digital als PDF oder als Print für deinen Schreibtisch";

            }


            


            let idAttribute = "data-product-id=" + product.productId;
            let productPrice = Math.ceil(product.price / 100);
            let productLink = `https://education.omr.com/products/${product.handle}?recommendedProduct=true`;
            
            let recommendationBox = document.createElement("div");
            recommendationBox.classList.add("recommendations-box");
            recommendationBox.innerHTML = `
                <div class="recommendations-progress-bar"></div>
                <div class="recommendations-content">
                    <div class="recommendations-image">
                        <a href="${productLink}"><img src="${imageLink}" alt="Produktbild"></a>
                        <p class="recommendations-price-left" ${idAttribute}>+${productPrice} €</p>
                    </div>
                    <div class="recommendations-text">
                        <h3 class="recommendations-headline-price" ${idAttribute}>+${productPrice} €</h3>
                        <h3 class="recommendations-headline">${title}</h3>
                        <p class="recommendations-benefits">${benefitText}</p>
                        <p class="recommendations-benefits-mobile">Live-Sessions mit Branchen-Expert*innen, Use Cases und Best Practices.</p>
                        <p class="recommendations-product-price"><strong>Jetzt für nur <span class="recommendations-in-text-price" ${idAttribute}>${productPrice} €</span> sichern.</strong></p>
                        <a onclick="showRecommendedProduct(this)" data-productlink="${productLink}" class="recommendations-cta-button">Weiterbildung entdecken</a>
                    </div>
                </div>
            `;

            upsellContainer.appendChild(recommendationBox);

            // Progress Bar nachträglich füllen
            let progressBar = recommendationBox.querySelector(".recommendations-progress-bar");
            setTimeout(() => {
                progressBar.style.width = "100%";
            }, 50); // Kurze Verzögerung, um die Animation sichtbar zu starten
        }, delay);

        delay += 1000; // Nächstes Element nach 1 Sekunde einfügen
    });
}


function showRecommendedProduct(element){
pushEventToDataLayer("recommendedProductAcceptButtonClick", "", window.location.href, "");
let productLink = element.getAttribute("data-productlink");
window.location.href = productLink;


}

function showProductPage(){

pushEventToDataLayer("recommendedProductDeclineButtonClick", "", window.location.href, "");

const main = document.querySelector("#main");

    // Falls auf einer Gempage-Seite -> einblenden
    const gempageContainer = document.querySelector(".gryffeditor");
    if (gempageContainer) {
        gempageContainer.style.opacity = "1";
    }

    
    main.style.visibility = "visible";

    const mainParent = main.parentNode;

    const recommendationsContainer = mainParent.querySelector(".recommendations-container");
    if(recommendationsContainer){

        mainParent.removeChild(recommendationsContainer);

    }

      const overlayButton = document.getElementById("myBtn");
    if(overlayButton){

        overlayButton.style.display = "";

    }

}